export enum CartonShortageStatus {
    YES = 'YES',
    NO = 'NO'
  }